import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import styles from './index.module.scss';

interface PropType {
  visibleDrawer: boolean;
  setVisibleDrawer: (visible: boolean) => void;
  children: any;
  title: string;
  handleReset: () => void;
}

export default function MobileSliderMenu({
  visibleDrawer,
  setVisibleDrawer,
  children,
  title,
  handleReset,
}: PropType) {
  return (
    <Sidebar
      visible={visibleDrawer}
      position='right'
      onHide={() => setVisibleDrawer(false)}
      className={styles.filterDrawer}
    >
      <div className={styles.headerBar}>
        <img
          src='/images/back.svg'
          alt=''
          onClick={() => setVisibleDrawer(false)}
        />
        <div className={styles.title}> {title}</div>
        <div className={styles.resetBtn} onClick={handleReset}>
          Reset
        </div>
      </div>
      {children}
    </Sidebar>
  );
}
